<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="User"
            bc3="Add"
            path="user"
          ></Breadcrumb>
        </div>

      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Email</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="email"
                                class="form-control"
                                :class="
                                  errorBag.has('email') ? 'is-invalid' : ''
                                "
                                name="email"
                                placeholder="Email"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('email')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("email") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">First Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="firstName"
                                class="form-control"
                                :class="
                                  errorBag.has('firstName') ? 'is-invalid' : ''
                                "
                                name="firstName"
                                placeholder="First Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('firstName')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("firstName") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Last Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="lastName"
                                class="form-control"
                                :class="
                                  errorBag.has('lastName') ? 'is-invalid' : ''
                                "
                                name="lastName"
                                placeholder="Last Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('lastName')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("lastName") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Password</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="password"
                                v-model="password"
                                class="form-control"
                                name="password"
                                placeholder="Password"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="name-icon">Roles</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <multiselect-->
<!--                                v-model="selectedRoles"-->
<!--                                :options="rolesOption"-->
<!--                                label="label"-->
<!--                                track-by="value"-->
<!--                                multiple-->
<!--                                placeholder="Select Roles"-->
<!--                                variant="primary"-->
<!--                              ></multiselect>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-end">
                        <div class="d-flex">
                          <button
                              type="button"
                              class="btn btn-primary mr-1 d-flex"
                              @click="sendCall"
                              :disabled="loading"
                          >
                            <Loader :loading="loading" :size="size"></Loader>
                            Save
                          </button>
                          <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="$router.back()"
                          >
                            Back
                          </button>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";

export default {
  components: {
    CommandIcon
  },
  mounted() {
    // setTimeout(() => {
    //   this.getrolesData();
    // }, 1000);
  },
  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      loading: false,
      size: "10px",
      selectedRoles: [],
      rolesOption: []
    };
  },
  computed: {},
  methods: {
    getrolesData() {
      this.makeRequest("post", "v1/get-role", { flag: "active", type : 1 }).then(
        callResponse => {
          if (!callResponse.error && callResponse.response.data) {
            let code = callResponse.response.data.code;
            let data = callResponse.response.data.data;
            data.key = "rolesCheckBoxData";
            if (code == 200) {
              let data = callResponse.response.data.data;
              data.map(item => {
                this.rolesOption.push({
                  value: item.id,
                  label: item.name
                });
              });
              this.$store.dispatch("set", data);
            }
          }
        }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            firstName : this.firstName,
            lastName : this.lastName,
            email : this.email,
            password : this.password,
          }
          // let rolesId = [];
          // this.selectedRoles.map(item => {
          //   rolesId.push(item.value);
          // });
          // data.append("roleId", JSON.stringify(rolesId));
          this.makeRequest("post", "v1/add-admin-user", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.push({
                    name: "admin-users",
                    // params: { add: true }
                  });
                }
              }
              this.loading = false;
            }
          );
        }
      });
    }
  }
};
</script>

